// Mock data for Divine Iris Healing website

export const programs = [
  {
    id: 1,
    title: "Atomic Weight Release Program (AWRP)",
    category: "Foundation",
    description: "The Atomic Weight Release Program is a deep, multi-layered healing journey that works at the atomic, subconscious, emotional level to address weight retention patterns.",
    image: "https://images.unsplash.com/photo-1545389336-cf090694435e?w=600&h=400&fit=crop",
    link: "/program/awrp"
  },
  {
    id: 2,
    title: "Atomic Musculoskeletal Regeneration Program",
    category: "Body-Based",
    description: "This program focuses on the musculoskeletal system — bones, joints, muscles, fascia, posture, and spine — understanding the body's natural regeneration capacity.",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&h=400&fit=crop",
    link: "/program/amrp"
  },
  {
    id: 3,
    title: "SoulSync Neuro-Harmonics",
    category: "Nervous System",
    description: "SoulSync Neuro-Harmonics focuses on nervous system regulation and brain coherence. Chronic stress, trauma, and emotional patterns are addressed at their root.",
    image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&h=400&fit=crop",
    link: "/program/soulsync"
  },
  {
    id: 4,
    title: "Money Magic Multiplier",
    category: "Abundance",
    description: "Money Magic Multiplier works on the emotional, subconscious, and ancestral relationship with money. For many, money is deeply tied to worthiness and safety.",
    image: "https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=600&h=400&fit=crop",
    link: "/program/money-magic"
  },
  {
    id: 5,
    title: "Quad Layer Healing",
    category: "Healing",
    description: "Quad Layer Healing works simultaneously on the conscious mind, subconscious mind, emotional body, and energetic memory (chakras) for complete transformation.",
    image: "https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=600&h=400&fit=crop",
    link: "/program/quad-layer"
  },
  {
    id: 6,
    title: "Divinity of Twinity",
    category: "Relationships",
    description: "Divinity of Twinity works on relationship imprints, attachment wounds, emotional dependency, and soul-level contracts for deeper connection and harmony.",
    image: "https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=600&h=400&fit=crop",
    link: "/program/divinity-twinity"
  }
];

export const sessions = [
  {
    id: 1,
    title: "Akashic Record Reading & Healing",
    description: "Akashic Record Reading is a sacred insight session that accesses the energetic archive of your soul's journey across lifetimes.",
    image: "https://images.unsplash.com/photo-1518531933037-91b2f5f229cc?w=400&h=300&fit=crop"
  },
  {
    id: 2,
    title: "Ancestral Healing",
    description: "Ancestral Healing is the sacred process of identifying and transforming inherited emotional, spiritual, and behavioral patterns passed through family lineages.",
    image: "https://images.unsplash.com/photo-1470290378698-263fa7ca60ab?w=400&h=300&fit=crop"
  },
  {
    id: 3,
    title: "Bid Adieu",
    description: "A sacred farewell ritual to lovingly release a soul who has transitioned. This session supports emotional closure, unresolved conversations, guilt, or unfinished feelings.",
    image: "https://images.unsplash.com/photo-1501139083538-0139583c060f?w=400&h=300&fit=crop"
  },
  {
    id: 4,
    title: "Chakra Healing",
    description: "Chakra Healing is a deep energetic alignment process that restores balance across the body's seven primary energy centers.",
    image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400&h=300&fit=crop"
  },
  {
    id: 5,
    title: "Circuit Healing",
    description: "Circuit Healing is a deep energetic cleansing process designed to address underlying imbalances contributing to health concerns.",
    image: "https://images.unsplash.com/photo-1518531933037-91b2f5f229cc?w=400&h=300&fit=crop"
  },
  {
    id: 6,
    title: "Cord Cutting",
    description: "Cord Cutting is a focused energetic release process that clears unhealthy attachments formed through intense emotional bonds, trauma, dependency, or prolonged stress.",
    image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=400&h=300&fit=crop"
  },
  {
    id: 7,
    title: "DNA Blueprint Reset",
    description: "DNA Blueprint Reset is a deep energetic recalibration designed to shift subconscious and inherited patterns that silently influence health, relationships, success.",
    image: "https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=400&h=300&fit=crop"
  },
  {
    id: 8,
    title: "Emotional Ease",
    description: "Emotional Ease is a restorative clearing process designed to gently dissolve accumulated emotional pressure, suppressed feelings, and chronic inner heaviness.",
    image: "https://images.unsplash.com/photo-1545389336-cf090694435e?w=400&h=300&fit=crop"
  },
  {
    id: 9,
    title: "Inner Child Healing",
    description: "Inner Child Healing is a deep restorative process that addresses unresolved emotional wounds formed during early life experiences.",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop"
  },
  {
    id: 10,
    title: "Soul Retrieval",
    description: "Soul Retrieval is a deep restorative process that focuses on reclaiming fragmented parts of your energy that may have split away during trauma, shock, or betrayal.",
    image: "https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=400&h=300&fit=crop"
  },
  {
    id: 11,
    title: "Tarot Reading",
    description: "Tarot Reading is an intuitive guidance session that offers clarity during uncertainty, transition, or important life decisions.",
    image: "https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=400&h=300&fit=crop"
  },
  {
    id: 12,
    title: "Trauma Clearing",
    description: "Trauma Clearing is a focused healing process designed to release the emotional and physiological imprints left behind by distressing or overwhelming experiences.",
    image: "https://images.unsplash.com/photo-1470290378698-263fa7ca60ab?w=400&h=300&fit=crop"
  }
];

export const testimonials = [
  { id: 1, videoId: "i3UJ6t6xYwQ", thumbnail: "https://img.youtube.com/vi/i3UJ6t6xYwQ/maxresdefault.jpg" },
  { id: 2, videoId: "GF5pkxAVfNc", thumbnail: "https://img.youtube.com/vi/GF5pkxAVfNc/maxresdefault.jpg" },
  { id: 3, videoId: "gBKFr8pnSKM", thumbnail: "https://img.youtube.com/vi/gBKFr8pnSKM/maxresdefault.jpg" },
  { id: 4, videoId: "yECblik4mHc", thumbnail: "https://img.youtube.com/vi/yECblik4mHc/maxresdefault.jpg" },
  { id: 5, videoId: "FVgxpMEMnoc", thumbnail: "https://img.youtube.com/vi/FVgxpMEMnoc/maxresdefault.jpg" },
  { id: 6, videoId: "UIO3eyGOt6o", thumbnail: "https://img.youtube.com/vi/UIO3eyGOt6o/maxresdefault.jpg" }
];

export const stats = [
  { value: "11k+", label: "HAPPY SOULS" },
  { value: "9+", label: "Years Experience" },
  { value: "11k+", label: "Transformations" },
  { value: "12+", label: "Awards Won" }
];
